import { IInitialisedPaymentLinkVm } from '../../../../api/initialised-payment-link-vm.model';
import { IMyOskSubscriptonsVm } from '../../../../api/my-osk-subscriptons-vm.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OskSubscriptionsService } from '../osk-subscriptions.service';
import { eModalRoles } from '../../../shared/models/modals';
import { Component, inject, OnInit } from '@angular/core';
import { IPlatformSubscriptionPlanVm } from '../../../../api/platform-subscription-plan-vm.model';

@Component({
  selector: 'app-osk-buy-subscription-form',
  templateUrl: './osk-buy-subscription-form.component.html',
  styleUrl: './osk-buy-subscription-form.component.scss',
})
export class OskBuySubscriptionFormComponent implements OnInit {
  private _dialogRef = inject(DynamicDialogRef);
  private _confifg = inject(DynamicDialogConfig);
  private _oskSubscriptionsService = inject(OskSubscriptionsService);

  public loading: boolean = false;
  public data: {
    selectedSubscriptionplanGuid: string | null;
    subscriptionPlans: IPlatformSubscriptionPlanVm[];
  } = this._confifg.data;
  availableSubscriptions: IPlatformSubscriptionPlanVm[] = [];
  selectedSubscriptions: {
    subscriptionPlan: IPlatformSubscriptionPlanVm;
    quantity: number;
  }[] = [];

  ngOnInit(): void {
    this.selectedSubscriptions =
      this._oskSubscriptionsService.getSelectedSubscriptionsFromLocalStorage();
    this.setAvailableSubscriptions();
    if (this.data.selectedSubscriptionplanGuid) {
      this.addSelectedSubscriptionToList();
    }
  }

  closeDialog(
    status: eModalRoles = eModalRoles.CLOSE,
    link: IInitialisedPaymentLinkVm | null = null
  ) {
    const result = {
      status,
      link,
    };
    this._dialogRef.close(result);
  }

  getNetValue(quantity: number, grossPrice: number, vatPercentage: number): number {
    const netPrice = grossPrice / (1 + vatPercentage / 100);
    return this.roundToTwo(quantity * netPrice);
  }

  getTotalValue(): {
    totalNetValue: number;
    totalGrossValue: number;
    totalVat: number;
  } {
    const totals = this.selectedSubscriptions.reduce(
      (acc, item) => {
        const grossPrice = item.subscriptionPlan.value;
        const vatPercentage = item.subscriptionPlan.vatPercentage;
  
        const netPrice = grossPrice / (1 + vatPercentage / 100);
        const netValue = item.quantity * netPrice;
        const vatValue = (netValue * vatPercentage) / 100;
        const grossValue = netValue + vatValue;
  
        acc.totalNetValue += netValue;
        acc.totalVat += vatValue;
        acc.totalGrossValue += grossValue;
  
        return acc;
      },
      { totalNetValue: 0, totalVat: 0, totalGrossValue: 0 } // Init
    );
  
    return {
      totalNetValue: this.roundToTwo(totals.totalNetValue),
      totalVat: this.roundToTwo(totals.totalVat),
      totalGrossValue: this.roundToTwo(totals.totalGrossValue),
    };
  }

  addSubscriptionToSelectedList(subscription: IPlatformSubscriptionPlanVm): void {
    const selectedPlan = {
      subscriptionPlan: subscription,
      quantity: 1,
    };
    this.selectedSubscriptions.push(selectedPlan);
    this.availableSubscriptions = this.availableSubscriptions.filter(
      (sub) => sub.guid !== subscription.guid
    );
    this.saveSelectedSubscriptionsToLocalStorage();
  }

  removeSubscriptionFromSelectedList(
    subscriptionPlan: IPlatformSubscriptionPlanVm
  ): void {
    this.availableSubscriptions.push(subscriptionPlan);
    this.selectedSubscriptions = this.selectedSubscriptions.filter(
      (sub) => sub.subscriptionPlan.guid !== subscriptionPlan.guid
    );
    this.saveSelectedSubscriptionsToLocalStorage();
  }

  buySubscriptions(): void {
    this.loading = true;

    this._oskSubscriptionsService.oskSetSubscriptionPayment$().subscribe({
      next: (res: IInitialisedPaymentLinkVm) => {
        this.loading = false;
        this.closeDialog(eModalRoles.SUCCESS, res);
      },
      error: (err) => {
        this.loading = false;
        console.error('My OSK platform subscription order error:', err);
      },
    });
  }

  saveSelectedSubscriptionsToLocalStorage(): void {
    if (this.selectedSubscriptions.length > 0) {
      const selectedSubscriptionsJSON = JSON.stringify(
        this.selectedSubscriptions
      );
      localStorage.setItem('selectedSubscriptions', selectedSubscriptionsJSON);
    } else {
      localStorage.removeItem('selectedSubscriptions');
    }
  }

  private setAvailableSubscriptions(): void {
    const selectedGuids = this.selectedSubscriptions.map(sub => sub.subscriptionPlan.guid);
    this.availableSubscriptions = this.data.subscriptionPlans.filter(sub => !selectedGuids.includes(sub.guid));
  }

  private addSelectedSubscriptionToList(): void {
    const selectedSubscription = this.availableSubscriptions.find(
      (item) => item.guid === this.data.selectedSubscriptionplanGuid
    );

    if (selectedSubscription) {
      this.addSubscriptionToSelectedList(selectedSubscription);
    }
  }

  private roundToTwo(value: number): number {
    return Math.round(value * 100) / 100; // Round to 2 decimal places
  }
}
